import {
  createEditorUrl,
  isFlowTemplate,
} from 'app/beta-editor/utils/FlowUtils';
import { getPathName, isPathNode } from 'app/beta-editor/utils/PathUtils';

import { RequiredBehaviors } from 'app/beta-editor/pages/types';

const pathSettingsBehavior: RequiredBehaviors = {
  href: ({ flow, node, pageKey }) => {
    const isTemplate = isFlowTemplate(flow.nodes);
    return createEditorUrl({
      flowId: flow.id,
      nodeId: node.id,
      pageKey,
      isTemplate,
    });
  },
  status: ({ node }) => (getPathName(node) ? 'success' : ''),
  label: () => 'Name',
  menuLabel: () => 'Name',
  crumbLabel: () => 'Name',
  visible: ({ node }) => isPathNode(node),
  data: () => {},
  isLocked: () => false,
  isClickable: () => true,
};

export default pathSettingsBehavior;
